import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { useStyle } from './useStyle';

const ActionButton = ({ onClick, link, text, type, disabled = false, style, className = '' }) => {
	const classes = useStyle(style)();
	const button = (
		<Button
			onClick={onClick}
			type={type}
			disableElevation
			className={className}
			classes={{ root: classes.root, disabled: classes.disabled }}
			disabled={disabled}
			variant='contained'>
			{text}
		</Button>
	);
	return disabled || !link ? button : <Link to={!disabled && link} children={button} />;
};

export default ActionButton;
